import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { InfoAfterLogin } from "../../Redux/Auth/Auth_Action";

const ChangePackageOption = () => {
	const navigate = useNavigate();
	const reduxState = useSelector((state) => state);
	const dispatch = useDispatch();
	// console.log('red state zzmmmmmzzzzzz', reduxState.Auth.activePackage);
	const [state, setState] = useState(null);

	useEffect(() => {
		window.scroll(0, 0);
	}, []);

	const GetInfoUser = () => {
		dispatch(InfoAfterLogin(reduxState.Auth.token))
			.then((res) => {
				setState(res?.data?.response?.data?.activeSubscription);
				// console.log('working', res.data.response.data.activePackage);
			})
			.catch((e) => {
				console.log("errrr from changepackageoptn", e);
			});
	};

	useEffect(() => {
		GetInfoUser();
	}, []);

	return (
		<div className="SubscriptionOption">
			{state ? (
				<div className="row">
					<div className="col-lg-12">
						<p className="f-pop-bold f-30">MY SUBSCRIPTION</p>
						{/* <p className='f-mon-bold f-25 clr-e0 ml-0 mt-4'>ChangePackageOption</p> */}
						{/* <p className='f-mon-semibold f-20 mb-0'>Package Includes</p> */}
					</div>

					<div className="col-lg-12">
						<div className="about_us packages subscribeopt">
							<div className="crd-flex">
								<div className="card mx-2 rounded-0 border-0 crd-top-pos h-100">
									<div className="card-body border-0 p-23rem crd-hover-bg tickchange p-white">
										<div className="row">
											<div className="col-lg-12">
												<p className="card-title mb-2">
													{reduxState?.Auth?.activePackage?.get_package?.title}
												</p>
											</div>
											<div
												dangerouslySetInnerHTML={{
													__html:
														reduxState?.Auth?.activePackage?.get_package
															?.package_offer,
												}}
												className="col-lg-12 text-left dan"
											></div>
											<div className="flx-bx-price">
												<div className="row">
													<div className="col-md-12">
														<div className="price-container">
															<p className="price mr-1 mb-0">
																<small>ACTIVATED</small>
															</p>
															{/* <p className='delete-price line_over ml-1'> $499</p> */}
														</div>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>

					<div className="col-lg-12 mt-4">
						<div className="d-flex res-col">
							<button
								onClick={() => {
									navigate("/mysubscription");
								}}
								className="bt-profile-grn ml-2"
							>
								UPDATE & CANCEL PACKAGE
							</button>
							{/* <button className='bt-profile-blu '>RENEW MEMBERSHIP</button> */}
							{/* <button className='bt-profile-pink '>CANCEL MEMBERSHIP</button> */}
						</div>
					</div>
				</div>
			) : (
				<p className="f-pop-bold f-30 subscribtiontext">
					NO SUBSCRIPTION ACTIVATED
				</p>
			)}
		</div>
	);
};

export default ChangePackageOption;
